import { useForm } from '@inertiajs/react'
import { FormEvent } from 'react'

interface Props {
  reset_password_token: string
  errors?: Record<string, string[]>
}

export default function ResetPassword({ reset_password_token, errors }: Props) {
  const { data, setData, put, processing } = useForm({
    user: {
      reset_password_token,
      password: '',
      password_confirmation: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    put('/users/password')
  }

  const errorMessages = Object.entries(errors ?? {}).map(([field, messages]) => {
    const label = field === 'reset_password_token' ? 'Reset link' : field.replace(/_/g, ' ')
    return `${label.charAt(0).toUpperCase()}${label.slice(1)} ${messages.join(', ')}`
  })

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">LendSolo</h1>
          <p className="text-gray-500 mt-1">Choose a new password</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 space-y-5">
          {errorMessages.length > 0 && (
            <div className="bg-red-50 text-red-700 text-sm px-4 py-3 rounded-lg space-y-1">
              {errorMessages.map((message) => (
                <p key={message}>{message}</p>
              ))}
            </div>
          )}

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
              New password
            </label>
            <input
              id="password"
              type="password"
              autoComplete="new-password"
              autoFocus
              required
              value={data.user.password}
              onChange={(e) => setData('user', { ...data.user, password: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            />
          </div>

          <div>
            <label htmlFor="password_confirmation" className="block text-sm font-medium text-gray-700 mb-1">
              Confirm new password
            </label>
            <input
              id="password_confirmation"
              type="password"
              autoComplete="new-password"
              required
              value={data.user.password_confirmation}
              onChange={(e) => setData('user', { ...data.user, password_confirmation: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            />
          </div>

          <button
            type="submit"
            disabled={processing}
            className="w-full py-2.5 px-4 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 disabled:opacity-50 transition-colors"
          >
            {processing ? 'Saving...' : 'Set new password'}
          </button>

          <p className="text-center text-sm text-gray-600">
            Link expired?{' '}
            <a href="/users/password/new" className="text-emerald-600 hover:text-emerald-700 font-medium">
              Request a new one
            </a>
          </p>
        </form>
      </div>
    </div>
  )
}
